import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOutletContext } from "react-router";
import InfiniteScrollComponent from "../../../components/Common/InfiniteScroll/InfiniteScrollComponent";
import {
  getAllProgramsActionHandler,
  getShotClassesActionHandler,
} from "../../../store/actions/actionHandlers/distributeActionHandler";
import DistributeSeriesList from "./DistributeSeriesList";
import classes from "./DistributeSeries.module.scss";
import BoxLayout from "../../../components/Common/BoxLayout/BoxLayout";
import {
  setSelectedSeriesDataAction,
  setSeriesDataAction,
} from "../../../store/actions/actionCreators/distributeActionCreator";
import Loader from "../../../components/Common/Loader/Loader";

const DistributeSeries = () => {
  const dispatch = useDispatch();
  const pageSize = 9;
  const { programCount, setProgramCount, tenantName, loading, setLoading } =
    useOutletContext();
  const distributeState = useSelector((state) => state.distributeReducer);
  const {
    selctedSeriesData,
    seriesData,
    selctedShotclassData,
    selctedCollectionData,
  } = distributeState;
  const [pageNum, setPageNum] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [deleteSeriesData, setDeleteSeriesData] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);


  useEffect(() => {
    if (deleteSeriesData) {
      dispatch(setSeriesDataAction([]));
      dispatch(
        getShotClassesActionHandler(
          "WithoutVTLT",
          false,
          "Published",
          "Program",
          "none",
          "none",
          1,
          pageSize,
          setLoading
        )
      );
      setDeleteModal(false);
      dispatch(
        getAllProgramsActionHandler(
          "WithoutVTLT",
          "Published",
          "Program",
          setProgramCount
        )
      );
      setDeleteSeriesData(null);
    }
  }, [deleteSeriesData, dispatch, setProgramCount, setLoading]);

  useEffect(() => {
    if (pageNum > 1)
      dispatch(
        getShotClassesActionHandler(
          "WithoutVTLT",
          false,
          "Published",
          "Program",
          "none",
          "none",
          pageNum,
          pageSize,
          setLoading
        )
      );
  }, [dispatch, pageNum, setLoading]);

  const fetchMoreData = () => {
    if (seriesData?.length >= programCount) {
      setHasMoreData(false);
      return;
    }
    setPageNum((prevState) => prevState + 1);
  };

  const handleCheckboxChange = (e, data) => {
    if (e?.target?.checked) {
      dispatch(setSelectedSeriesDataAction([...selctedSeriesData, data]));
      const updatedData = seriesData?.map((item) => {
        return {
          ...item,
          Programs: {
            ...item.Programs,
            checked:
              data?.ID === item?.Programs?.ID || item?.Programs?.checked
                ? true
                : false,
          },
        };
      });
      dispatch(setSeriesDataAction(updatedData));
    } else {
      const updatedData = selctedSeriesData?.filter((item) => {
        return item?.ID !== data?.ID;
      });
      dispatch(setSelectedSeriesDataAction(updatedData));
      const selectedpdatedData = seriesData?.map((item) => {
        return {
          ...item,
          Programs: {
            ...item.Programs,
            checked:
              data?.ID === item?.Programs?.ID && item?.Programs?.checked
                ? false
                : item?.Programs?.checked
                ? true
                : false,
          },
        };
      });
      dispatch(setSeriesDataAction(selectedpdatedData));
    }
  };

  return (
    <BoxLayout>
      {loading && (
        <div className={classes.seriesLoader}>
          <Loader />
        </div>
      )}
      {seriesData?.length === 0 && !loading && (
        <div className={classes.seriesNotFoundText}>No Series Found</div>
      )}
      {programCount > pageSize && seriesData?.length > 0 && !loading && (
        <InfiniteScrollComponent
          dataLength={seriesData?.length ? seriesData.length : pageSize}
          fetchMoreData={fetchMoreData}
          hasMoreData={hasMoreData}
          height={"70rem"}
          loader={true}
        >
          <DistributeSeriesList
            seriesData={seriesData}
            setDeleteSeriesData={setDeleteSeriesData}
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            handleCheckboxChange={handleCheckboxChange}
            tenantName={tenantName}
          />
        </InfiniteScrollComponent>
      )}
      {programCount <= pageSize && seriesData?.length > 0 && !loading && (
        <DistributeSeriesList
          seriesData={seriesData}
          setDeleteSeriesData={setDeleteSeriesData}
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
          handleCheckboxChange={handleCheckboxChange}
          tenantName={tenantName}
        />
      )}
      {/* {(selctedShotclassData?.length > 0 ||
        selctedSeriesData?.length > 0 ||
        selctedCollectionData?.length > 0) && (
        <DistributeFooter tenantName={tenantName} />
      )} */}
    </BoxLayout>
  );
};

export default DistributeSeries;
